import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import {
  getFollowMeFollowingAccounts,
  getFollowMeUserProfileById,
  getPrincipleFollowMeUserProfile,
} from './api'

export const followMePrincipleProfileQuery = queryOptions({
  queryKey: queryKeys.followMeAccountProfile,
  queryFn: getPrincipleFollowMeUserProfile,
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  gcTime: 1_000 * 60 * 30, // 30min
})

export const followMeProfileByIdQuery = (id: string) =>
  queryOptions({
    queryKey: [queryKeys.followMeAccountProfile, id],
    queryFn: () => getFollowMeUserProfileById(id),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    gcTime: 1_000 * 60 * 30, // 30min
  })

export const followMeFollowingProfilesQuery = queryOptions({
  queryKey: queryKeys.followMeFollowingAccounts,
  queryFn: getFollowMeFollowingAccounts,
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  gcTime: 1_000 * 60 * 30, // 30min
})
